"use strict";
exports.__esModule = true;
exports.profile = void 0;
exports.profile = {
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@gmail.com',
    uuid: 'myuid'
};
